import { Col } from "react-bootstrap";
import { Input } from "../Input";
import { DefaultInput } from "../DefaultInput";
import { SellingStrategyValueInput } from "../SellingStrategyValueInput";
import { useTranslation } from "react-i18next";

interface SpotCGRPSellingStrategyProps {
    setValues: (value: any, key: string, isUserSelection?: boolean) => void;
    inputValues: any;
}

export const SpotCGRPSellingStrategy = (props: SpotCGRPSellingStrategyProps) => {
    const { t } = useTranslation();

    return (
        <>
            <Col className="multipleInputsRow">
                <Input required title={t("txt_net_budget")}>
                    <DefaultInput
                        onChange={(value: any) => props.setValues(parseFloat(value), "fullBudget", true)}
                        type="currency"
                        iconKey="currency"
                        placeholder={t("txt_net_budget")}
                        value={props.inputValues.fullBudget}
                        params={{numberMaxValue: 9999999999, numberIsInterger: true}}
                    />
                </Input>
            </Col>
            <Col className="multipleInputsRow">
                <Input
                    required
                    title={t("txt_method_grpcs")}
                >
                    <SellingStrategyValueInput
                        disabled={false}
                        iconKey="currency"
                        setValues={(value, key) => props.setValues(value, key)}
                        value={props.inputValues.sellingStrategyValue ? props.inputValues.sellingStrategyValue : 0}
                    />
                </Input>
            </Col>
        </>
    );
}